
/**
* src/web/components/user-monthly-summary-page.jsx
* ユーザの月間サマリーページ（ポップアップ）
*/
import React from 'react'
import connect from '../../connects/user-monthly-summary-page'
import classnames from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Button,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import MonthlySummaryTheme from './themes/user-monthly-summary-page.css'
import UserMonthlyActivitiesTable from './user-monthly-activities-table'

class UserMonthlySummaryPage extends React.Component {

  onClick = (isAdd)=> {
    const num = isAdd && 1 || -1
    const dt = moment(this.props.ui.date.clone().add( num, 'month' ))
    this.props.updateUI({ date: dt})
  }

  onClose = ()=> {
    this.props.onClose()
    this.props.updateUI({ date: moment(), edit: false })
    this.props.startDate && this.props.fetchActivityReports(this.props.group, this.props.startDate)
  }

  onEdit = () => this.props.updateUI({ edit: !this.props.ui.edit })

  render() {
    const {
      t,
      ui,
      updateUI,
      user,
      group,
      onClose,
      open,
      monthlySummaryExportUrl,
      currentUser,
      reportDate,
    } = this.props

    return (
      <Dialog theme={MonthlySummaryTheme} 
          active={open}
          onEscKeyDown={this.onClose}
          onOverlayClick={this.onClose}
          title={ui.edit ? t('label:月間サマリー編集モード', { name: user.name }) : t('label:月間サマリー', { name: user.name })}
          actions={[!ui.edit && { label: t('label:閉じる'), onClick: this.onClose, raised: true }]}>
        <div className={MonthlySummaryTheme.displayMonth}>
          <div className={!ui.edit ? MonthlySummaryTheme.cursor : MonthlySummaryTheme.notAllowed} onClick={()=> !ui.edit && this.onClick(false)}><FontIcon value='navigate_before' /></div>
          <span>{ t('label:年月', { year: ui.date.year(), month: ui.date.month() + 1 })}</span>
          <div className={!ui.edit ? MonthlySummaryTheme.cursor : MonthlySummaryTheme.notAllowed} onClick={()=> !ui.edit && this.onClick(true)}><FontIcon value='navigate_next' /></div>
        </div>
        {!ui.edit &&
        <div>
          <div className={MonthlySummaryTheme.icons}>
            <div className={MonthlySummaryTheme.icon}>
              <FontIcon value='event_note' className={MonthlySummaryTheme.descFontIcon} />
              <span className={MonthlySummaryTheme.descText}>{t('label:日報アイコン')}</span>
            </div>
            <div className={MonthlySummaryTheme.icon}>
              <FontIcon value='insert_chart' className={MonthlySummaryTheme.descFontIcon} />
              <span className={MonthlySummaryTheme.descText}>{t('label:KPIアイコン')}</span>
            </div>
            <div className={MonthlySummaryTheme.icon}>
              <FontIcon value='assignment' className={MonthlySummaryTheme.descFontIcon} />
              <span className={MonthlySummaryTheme.descText}>{t('label:ノートアイコン')}</span>
            </div>
            <div className={MonthlySummaryTheme.icon}>
              <FontIcon value='event_available' className={MonthlySummaryTheme.scheduleIcon} />
              <span className={MonthlySummaryTheme.descText}>{t('label:提出予定')}</span>
            </div>
          </div>
        </div>}
        <UserMonthlyActivitiesTable 
          reportDate={reportDate}
          group_id={group.group_id} 
          user_id={user.user_id} 
          current_user_id={currentUser.user_id} 
          changeEdit={this.onEdit}
          edit={ui.edit}
          date={ui.date} 
          group_admin={group.is_admin}
          />
      </Dialog>
    )
  }
}

export default connect(UserMonthlySummaryPage)


// WEBPACK FOOTER //
// ./src/web/components/user-monthly-summary-page.jsx